export default "__VITE_ASSET___l4LPHaE__"